module.exports = __webpack_public_path__ + "static/media/slide.a225962f.svg";